export type HomeLink = {
  title: string;
  to: string;
  icon?: string;
};

export const toolLinks: HomeLink[] = [
  {
    title: 'Blokk',
    to: '/catalog/default/component/blokk-docs/docs',
    icon: 'blokk',
  },
  {
    title: 'GitHub',
    to: 'https://github.com/code-obos',
    icon: 'github',
  },
  {
    title: 'Spacelift',
    to: 'https://code-obos.app.spacelift.io/',
    icon: 'spacelift',
  },
  {
    title: 'Splunk',
    to: 'https://oboscloud.splunkcloud.com/en-US/app/search/search',
    icon: 'splunk',
  },
  {
    title: 'CloudID',
    to: 'https://cloudid.obos.dev/',
    icon: 'cloudid',
  },
];

export const usefulLinks: HomeLink[] = [
  {
    title: 'FAQ',
    to: '/catalog/default/component/blokk-docs/docs/faq',
    icon: 'faq',
  },
  {
    title: 'Request CloudID Access',
    to: 'https://myaccess.microsoft.com/@obosonline.onmicrosoft.com#/access-packages/dd3c7a7b-372f-4a6f-a512-9c583b5c3cbb',
    icon: 'cloudid',
  },
  {
    title: 'Request CMDB ID',
    to: 'https://obos.service-now.com/sp?id=sc_cat_item&sys_id=19fcc4731b0d6e101e67a934604bcbb3&sysparm_category=c8eed3c69790061016477186f053afa5',
    icon: 'cmdb',
  },
  {
    title: 'New Landing Zone Request [Online]',
    to: 'https://github.com/code-obos/obos-lz-management/issues/new?template=lz-request-online.yaml',
    icon: 'github',
  },
  {
    title: 'New Landing Zone Request [Sandbox]',
    to: 'https://github.com/code-obos/obos-lz-management/issues/new?template=lz-request-sandbox.yaml',
    icon: 'github',
  },
  {
    title: 'New Landing Zone Request [Corp]',
    to: 'https://github.com/code-obos/obos-lz-management/issues/new?template=lz-request-corp.yaml',
    icon: 'github',
  },
];
